



































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {InputCargaSchema} from '@/schema/resource/Carga/InputCargaSchema'

@Component
export default class PersistCargaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaSchema()
  carga = new Carga()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionSistema.listSistema()
    this.schema.collectionResponsavel.listResponsavel()
    this.schema.collectionAuditoria.listAuditoria()
    this.schema.collectionEndereco.listEndereco()
    this.schema.collectionMotorista.listMotorista()
    this.schema.collectionTipoOcorrencia.listTipoOcorrencia()
    this.schema.collectionPosicaoMotorista.listPosicaoMotorista()
    this.schema.collectionResponsavelFilial.listResponsavelFilial()
    this.schema.collectionStatusCarga.listStatusCarga()
    this.schema.collectionTipoPessoaRecebedor.listTipoPessoaRecebedor()
    this.schema.collectionCentroDeCusto.listCentroDeCusto()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.carga.getCarga(id)
    }

    $.await.done('getCarga')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.carga.persistCarga()
    await Helper.successAndPush('system.success.persist', '/carga/list')
  }
}
